import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useChange } from './FileInput';

function onDragOver(e) {
	e.stopPropagation();
	e.preventDefault();
}

export default function FileDrop({ onChange, maxSize, value, className, ...props }) {
	const { t } = useTranslation();
	const [dragActive, setDragActive] = useState(false);
	const change = useChange(onChange, maxSize, props.multiple && value);
	if(!onChange) {
		return null;
	}
	return <>
		<div onDragOver={onDragOver} onDragEnter={() => setDragActive(true)} onDrop={e => {
			e.preventDefault();
			e.stopPropagation();
			change(e.dataTransfer.files);
			setDragActive(false);
		}} className={['d-flex flex-column align-items-center justify-content-center m-2 file-drop text-center', className].filter(Boolean).join(' ')}>
			{dragActive ? <div className="file-release d-flex flex-column justify-content-center h4" onDragLeave={() => setDragActive(false)}>
				{t('FileDrop.Release')}
			</div> : <>
				{t('FileDrop.Drag')}
				<label>
					<span className="btn btn-primary">{t('FileDrop.Select')}</span>
					<input {...props} hidden type="file" onChange={e => change(e.target.files)} />
				</label>
			</>}
		</div>
		{value?.length > 0 && <div className="m-2">
			{Array.prototype.map.call(value, (file, i) => {
				return <div key={i} className="my-2">{file.name} <button onClick={e => {
					e.preventDefault();
					const dt = new DataTransfer();
					for(let j = 0; j < value.length; j++) {
						if(i !== j) {
							dt.items.add(value[j]);
						}
					}
					onChange({ target: { value: dt.files } });
				}} className="btn btn-danger btn-sm">&times;</button></div>;
			})}
		</div>}
	</>;
}
